import {
  canViewSecurityAddendums,
  canViewSecurityReports,
  type RouteMeta,
} from 'v2/shared/utils/role-based-visibility'

/** Trust & Legal's tabs in display order, each behind its own check; routes and page read this. */
export const TRUST_AND_LEGAL_TABS = [
  {
    key: 'security-addendums',
    title: 'Security Addendums',
    path: '/trust-and-legal/security-addendums',
    canView: canViewSecurityAddendums,
  },
  {
    key: 'security-reports',
    title: 'Security Reports',
    path: '/trust-and-legal/security-reports',
    canView: canViewSecurityReports,
  },
] as const

/** The tabs this viewer may open. */
export const trustAndLegalTabs = (meta?: RouteMeta) =>
  TRUST_AND_LEGAL_TABS.filter((tab) => tab.canView(meta))

/** Trust & Legal Compliance (Settings): open when a tab is. Fails closed while the flags load. */
export const canViewTrustAndLegal = (meta?: RouteMeta): boolean =>
  trustAndLegalTabs(meta).length > 0
